import SearchInput from "../../gui/TextInput/SearchInput";
import GUI from "../../gui/GUI";
import { usePath } from "../../libs/path/PathProvider";

export default function RecipeSearch(props:{className:string}){
    const {setQuery,query} = usePath()
    const onSearch = (search:string) => setQuery({search})
    const defaultValue = query["search"] as string || ""
    return <div className={GUI.joinClass("search",props.className)}>
        <SearchInput id="recipes" onSearch={onSearch} placeholder="Search" canClear={true} inputProps={{autoComplete:"off"}} defaultValue={defaultValue}/>
    </div>
}